// This Form Was Designed To Be A Standalone
// Component Which Will Be Called From
// Anywhere In The Software

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
// import "../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../../baseurl";
import axios from "axios";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import Select from "react-select";

export default function ItemForm(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");

  const [loadingResponce, setLoadingResponce] = useState(false);
  const [requiredLovs, setRequiredLovs] = useState(false);
  const [checkItemType, setcheckItemType] = useState(false);

  const [data, setData] = useState({
    itemSubCategoryDesc: "",
    itemSubCategoryCode: "",
    item: "",
    showModalItemCategory: false,
    showModalItemSubCategory: false,
    showModalAddNew: true,
    activity: props?.propData?.location?.rowData?.referencePk,
  });
  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    let uomId = data.uom?.id;
    if (uomId) props.toggle(uomId);
    else props.toggle();
  };
  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    if (
      name === "defaultRateShow" &&
      value === "1" &&
      Number(data.defaultRate) <= 0
    ) {
      swal({
        title: "Default rate should be more than 0",
        text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
        icon: "warning",
      });
      setData({
        ...data,
        defaultRate: 1,
        [name]: value,
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };
  const selectItemEvent = (...itemField) => {
    if (itemField && requiredLovs === false) {
      setcheckItemType(false);
    } else {
      setcheckItemType(true);
    }
    setData({
      ...data,
      item: itemField[0],
    });
  };
  const [getDataItemCatType, setgetDataItemCatType] = useState([]);

  useEffect(() => {
    let itemCatTypeData = [];
    axios
      .post(
        `${baseurl}/lovs/getItemCategory`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          itemCatTypeData.push({
            id: responseData[loop]["id"],
            label: responseData[loop]["description"],
            value: responseData[loop]["description"],
            isDisabled: false,
          });
        }
        setgetDataItemCatType({
          ...getDataItemCatType,
          itemCatTypeOptions: itemCatTypeData,
        });
      })
      .catch((err) => {
        console.log(err);
      });

    if (props.EditData > -1) {
      let resData;
      let tableId = props.EditData;
      axios
        .post(
          `${baseurl}/masterData/getItemSubCatDataById`,
          { id: tableId, companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((res) => {
          resData = res.data.data[0];
          //   let Id = resData["sector_id"];
          let itemSubCategoryCode = res.data.data[0]?.code;
          let itemSubCategoryDesc = res.data.data[0]?.description;
          let item = resData["label"];
          let itemId = resData["catId"];
          item = {
            id: itemId,
            label: item,
          };
          setData({
            ...data,
            // Id,
            itemSubCategoryDesc,
            itemSubCategoryCode,
            itemCat: tableId,
            item,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
    }
  }, []);
  const getUserIp = async function () {
    let res = await GetIp();
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    setLoadingResponce(true);
    var companyId = localStorage.getItem("companyId");
    const { item } = data;
    let { userIp, userCountry } = await getUserIp();
    if (item?.id) {
      if (props.EditData > -1) {
        let Id = props.EditData;
        axios
          .post(
            `${baseurl}/masterData/updateItemSubCat`,
            {
              subCatCode: data.itemSubCategoryCode,
              subCatDesc: data.itemSubCategoryDesc,
              itemCat: data.item?.id,
              editId: Id,
              username: username,
              companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.code == "1451") {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Success!",
                text: "Updated!",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
            // return;
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        axios
          .post(
            `${baseurl}/masterData/getAddItemSubCategory`,
            {
              companyId,
              subCatDesc: data.itemSubCategoryDesc,
              subCatCode: data.itemSubCategoryCode,
              username: username,
              itemCat: data.item?.id,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.code === 501) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Item Sub Category Added",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);
            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      setLoadingResponce(false);
      swal({
        title: "Required Fields",
        text: "Please select all *required fields.",
        icon: "warning",
      });
      setRequiredLovs(true);
    }
  };
  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div>
          <Modal
            show={data.showModalAddNew}
            size="md"
            onHide={toggleAddNew}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={toggleAddNew}
              className=" Creative-Invoice-header-styling"
            >
              <strong>
                <h4> {props.EditData > -1 ? "Update" : "Add"} Sub Category </h4>
              </strong>
            </Modal.Header>
            <Modal.Body>
              <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                <div className="row">
                  <div className="col-md-12">
                    <Label translate="yes" style={{ fontWeight: "bold" }}>
                      Item Category:
                      <h8 style={{ color: "tomato" }}>*</h8>
                    </Label>
                    <Select
                      value={data.item}
                      onChange={selectItemEvent}
                      options={getDataItemCatType.itemCatTypeOptions}
                      required
                      isDisabled={data?.disabled}
                      isClearable
                      name="item"
                      placeholder="Type"
                    />
                    {requiredLovs && !data.item?.id && (
                      <span className="text-danger">Item is required!</span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <Label style={{ fontWeight: "bold" }}>
                      Sub-Category Code
                    </Label>
                    <Input
                      value={data.itemSubCategoryCode}
                      onChange={inputEvent}
                      required
                      name="itemSubCategoryCode"
                      id="itemSubCategoryCode"
                      isClearable
                    />
                  </div>
                  <div className="col-md-6">
                    <Label style={{ fontWeight: "bold" }}>
                      Sub-Category Description
                    </Label>
                    <Input
                      value={data.itemSubCategoryDesc}
                      onChange={inputEvent}
                      required
                      name="itemSubCategoryDesc"
                      id="itemSubCategoryDesc"
                      isClearable
                    />
                  </div>
                </div>
                <hr
                  style={{
                    border: "1px solid ",
                    marginBottom: "3vh",
                    marginTop: "3vh",
                    borderColor: "E4E5E6",
                  }}
                />
                <FormGroup>
                  <Button
                    className="mr-1 invoiceSubmitButton "
                    disabled={loadingResponce}
                  >
                    {props.EditData > -1 ? "Update" : "Save"} Changes
                  </Button>
                  <Button
                    onClick={() => toggleAddNew()}
                    className="mr-1"
                    size="sm"
                  >
                    Cancel
                  </Button>
                </FormGroup>
              </Form>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
